/* eslint-disable react/prop-types */
import React from 'react'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PATH as INFO_PATH, HEADER as INFO_HEADER } from '../../project-information/constants'

import StatusBar from '../../../components/project-profit-sheet/StatusBar'

import { ppsSelector, authSelector } from '../../../selectors'

/**
 * @typedef {import('react-router-dom').RouteComponentProps} RouteComponentProps
 */

/**
 * @typedef {object} Props
 * @property {object} profitData
 * @property {object} user
 * @property {React.ReactNode} children
 */

/** @param {Props & RouteComponentProps} props */
function StatusBarContainer(props) {
  const { id: project_id = '' } = props.match.params
  const {
    is_system_admin,
    is_management_role,
    is_vp_avp_role,
    is_pm_role,
    is_lob_lead_role,
  } = props.user

  // check whether if user permissions fall into these roles
  const projectInfoEnabled = [
    is_system_admin,
    is_management_role,
    is_vp_avp_role,
    is_pm_role,
    is_lob_lead_role,
  ].some(Boolean)

  function handleInfoClick() {
    const { id: project_id = '' } = props.match.params
    props.history.push(`${INFO_PATH}/${project_id}`, {
      header: INFO_HEADER,
    })
  }

  return (
    <StatusBar
      projectId={ project_id }
      status={ props.profitData.status }
      code={ props.profitData.project_code }
      client={ props.profitData.client_name }
      project_name={ props.profitData.project_name }
      description={ props.profitData.description }
      lob={ props.profitData.lob_name }
      key_project_manager={ props.profitData.key_project_manager }
      start={ props.profitData.start_date }
      end={ props.profitData.end_date }
      submit={ props.profitData.submit_date }
      unapproved_users={ props.unapprovedUsers }
      onInfoClick={ handleInfoClick }
      projectInfoEnabled={ projectInfoEnabled }
    >
      {props.children}
    </StatusBar>
  )
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
  unapprovedUsers: ppsSelector.getUnapprovedUsers,
  user: authSelector.getAuthUser,
})

export default compose(
  connect(mapStateToProps),
  withRouter
)(StatusBarContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/StatusBarContainer.js